export default {"src":"/_next/static/media/green-location-pin.ab4e8053.svg","height":13,"width":11};